import { render, staticRenderFns } from "./Video_Settings.vue?vue&type=template&id=c7d03e08&"
import script from "./Video_Settings.vue?vue&type=script&lang=js&"
export * from "./Video_Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports